export default __webpack_public_path__ + "static/10563-43a840aaa95ebb570a03dd7eb3ea65d6.jpg";